module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isEarlyAdopter && _vm.hasAnyLiveFlag) ? _c('div', [(_vm.open) ? _c('div', {
    staticClass: "ql-ea-backdrop",
    on: {
      "click": function($event) {
        _vm.open = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ql-ea-badge-wrap"
  }, [_c('button', {
    staticClass: "ql-ea-badge",
    attrs: {
      "title": "Early-adopter preview"
    },
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_vm._v("\n            ✨ Early-adopter preview active\n        ")]), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "ql-ea-pop",
    on: {
      "keydown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', {
    staticClass: "ql-ea-pop-text"
  }, [_vm._v("\n            You're previewing pre-release features. If something's broken, you can turn the\n            preview off and go back to the standard Cuelist.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "ql-ea-pop-note"
  }, [_vm._v("An admin can turn it back on later.")]), _vm._v(" "), _c('div', {
    staticClass: "ql-ea-pop-actions"
  }, [_c('button', {
    staticClass: "ql-ea-btn ghost",
    attrs: {
      "disabled": _vm.working
    },
    on: {
      "click": function($event) {
        _vm.open = false
      }
    }
  }, [_vm._v("Keep it on")]), _vm._v(" "), _c('button', {
    staticClass: "ql-ea-btn danger",
    attrs: {
      "disabled": _vm.working
    },
    on: {
      "click": _vm.turnOff
    }
  }, [_vm._v("\n                " + _vm._s(_vm.working ? 'Turning off…' : 'Turn off preview') + "\n            ")])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff404bc8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EarlyAdopterBadge.vue
// module id = 1297
// module chunks = 21